/** Link wa.me do WhatsApp comercial da FabChat */
export const FABCHAT_WHATSAPP_URL = "https://wa.me/5551980577709";
